import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CurrencyField,
  DataTable,
  DateTimeField,
  Field,
} from '../../commons/DataTable';
import ClaimStatusField from '../../commons/DataTable/ClaimStatusField';
import EditClaimModal from './EditClaimModal';
import DeleteClaimModal from './DeleteClaimModal';
import BadgeField from './BadgeField';
import AppointedSupplierField from './AppointedSupplierField';

function ClaimsTable({
  data,
  total,
  offset,
  limit,
  onFilter,
  searchSuppliers,
  bottomRow,
  profile,
  onClaimUpdate,
  onClaimDelete,
  events,
}) {
  const [t] = useTranslation();

  return (
    <DataTable
      data={data}
      total={total}
      offset={offset}
      limit={limit}
      onFilter={onFilter}
      emptyText={t('COMMON:NO_DATA')}
      bottomRow={bottomRow}
    >
      <Field title="Numero di sinistro" source="claimNumber" />
      <DateTimeField
        title="Data del sinistro"
        source="start_date"
        format="DD/MM/YYYY"
      />

      <Field title="Evento" source="event.name" />
      <Field title="Perito" source="expert" />
      <CurrencyField
        title="Riserva"
        source="reserve"
        className="txt-table-right"
      />
      <Field title="Note" source="notes" />

      <Field title="Rami" source="insurance.branch" />
      <Field title="Codice polizza" source="insurance.policy_code" />
      <Field title="Etichetta polizza" source="insurance.insurance_code" />
      <Field title="Referente" source="admin.businessName" />
      <Field title="Codice fiscale referente" source="admin.taxCode" />
      <Field
        title="Fornitore"
        source="supplier.businessName"
        visible={!['SUPPLIER_INS'].includes(profile?.type)}
      />
      <Field
        title="Codice fiscale fornitore"
        source="supplier.taxCode"
        visible={!['SUPPLIER_INS'].includes(profile?.type)}
      />

      <Field title="Liquidatore" source="liquidator" />
      <DateTimeField
        title="Data pagamento"
        source="date_paid"
        format="DD/MM/YYYY"
      />
      <CurrencyField
        title="Importo pagato"
        source="paid_amount"
        className="txt-table-right"
      />
      <ClaimStatusField title="Esito" source="status" />
      <BadgeField
        title="Fornitore interno"
        source="intern"
        className="text-center"
      />
      <AppointedSupplierField
        title="Fornitore incaricato"
        source="appointedSupplier.businessName"
      />

      <EditClaimModal
        title="Modifica"
        onConfirm={onClaimUpdate}
        searchSuppliers={searchSuppliers}
        events={events}
      />

      <DeleteClaimModal title="Elimina sinistro" onConfirm={onClaimDelete} />
    </DataTable>
  );
}

export default ClaimsTable;
